import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useRecordatorios() {
  return useQuery({
    queryKey: ['recordatorios'],
    queryFn: () => api.get('/recordatorios').then((r) => r.data),
  });
}

export function useRecordatoriosHoy() {
  return useQuery({
    queryKey: ['recordatorios', 'hoy'],
    queryFn: () => api.get('/recordatorios/hoy').then((r) => r.data),
  });
}

export function useCreateRecordatorio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/recordatorios', data).then((r) => r.data),
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: ['recordatorios'] });
      if (variables.lead_id) {
        qc.invalidateQueries({ queryKey: ['lead', variables.lead_id] });
      }
    },
  });
}

export function useUpdateRecordatorio(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.patch(`/recordatorios/${id}`, data).then((r) => r.data),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: ['recordatorios'] });
      if (data?.lead_id) qc.invalidateQueries({ queryKey: ['lead', data.lead_id] });
    },
  });
}
